import FieldsPageView from "./FieldsPageView";

function FieldsPage() {
  return <FieldsPageView />;
}

export default FieldsPage;
